import React, { useState } from "react";
import { Container, Row, Tab, Tabs } from "react-bootstrap";
import Enter from "../Enter/Enter";
import Display from "../Display/Display";
import "./main.css";
import { ToastContainer } from "react-toastify";
const MainUserSub = () => {
  const [key, setKey] = useState("enter");
  const [Userid, setUserid] = useState("");
  const [QuoteId, setQuoteId] = useState(1);
  const [Username, setUsername] = useState("");
  const [RowId, setRowId] = useState("");
  const [Appuserid, setAppuserid] = useState("");
  const [Datee2, setDate2] = useState("");
  const [DateTwo, setDateTwo] = useState("");
  const [Datee1, setDate1] = useState("");
  const [val, setVal] = useState(0);
  const [File, setFile] = useState("");
  const [Base64, setBase64] = useState("");
  const [Feedback, setFeedback] = useState("");
  const [Free, setFree] = useState(false);
  const [Paid, setPaid] = useState(false);
  const [Active, setActive] = useState(false);
  const [showDelete, setshowDelete] = useState(false);
  const [showEdit, setshowEdit] = useState(false);
  const [Archivemega, setArchivemega] = useState(200);
  const [moye, setmoye] = useState(0);
  const [duration, setDuration] = useState("");
  const [isPress, setIsPress] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [isValue, setisValue] = useState(false);

  const yearCount = [1, 2, 3];
  const monthCount = [6];
  const [foc, setfoc] = useState(false);

  const [loading, setLoading] = useState(true);

  return (
    <div className="main">
      <Container>
        <h4 className="text-center">إدارة بيانات المشتركين</h4>
        <Row>
          <div className="col-md-12">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="mb-3">
              <Tab eventKey="enter" title="إدخال">
                <Enter
                  setUserid={setUserid}
                  setisValue={setisValue}
                  isValue={isValue}
                  Userid={Userid}
                  File={File}
                  DateTwo={DateTwo}
                  setDateTwo={setDateTwo}
                  setFile={setFile}
                  Base64={Base64}
                  setBase64={setBase64}
                  Datee1={Datee1}
                  Username={Username}
                  setUsername={setUsername}
                  isEdit={isEdit}
                  RowId={RowId}
                  setisEdit={setisEdit}
                  setDate1={setDate1}
                  Datee2={Datee2}
                  setDate2={setDate2}
                  QuoteId={QuoteId}
                  Feedback={Feedback}
                  setFeedback={setFeedback}
                  Free={Free}
                  setFree={setFree}
                  Paid={Paid}
                  setPaid={setPaid}
                  Active={Active}
                  setActive={setActive}
                  val={val}
                  setVal={setVal}
                  Archivemega={Archivemega}
                  setArchivemega={setArchivemega}
                  moye={moye}
                  setmoye={setmoye}
                  duration={duration}
                  setDuration={setDuration}
                  yearCount={yearCount}
                  monthCount={monthCount}
                  foc={foc}
                  setfoc={setfoc}
                  setLoading={setLoading}
                  setIsPress={setIsPress}
                  loading={loading}
                  isPress={isPress}
                />
              </Tab>
              <Tab eventKey="display" title="عرض">
                <Display
                  setKey={setKey}
                  setisValue={setisValue}
                  isValue={isValue}
                  Username={Username}
                  setUsername={setUsername}
                  setUserid={setUserid}
                  DateTwo={DateTwo}
                  setDateTwo={setDateTwo}
                  RowId={RowId}
                  setRowId={setRowId}
                  setisEdit={setisEdit}
                  setFile={setFile}
                  key={key}
                  setAppuserid={setAppuserid}
                  Appuserid={Appuserid}
                  Datee1={Datee1}
                  setDate1={setDate1}
                  Datee2={Datee2}
                  setDate2={setDate2}
                  QuoteId={QuoteId}
                  setQuoteId={setQuoteId}
                  showDelete={showDelete}
                  setshowDelete={setshowDelete}
                  showEdit={showEdit}
                  setshowEdit={setshowEdit}
                  Feedback={Feedback}
                  setFeedback={setFeedback}
                  Free={Free}
                  setFree={setFree}
                  Paid={Paid}
                  setPaid={setPaid}
                  Active={Active}
                  setActive={setActive}
                  val={val}
                  setVal={setVal}
                  Archivemega={Archivemega}
                  setArchivemega={setArchivemega}
                  moye={moye}
                  setmoye={setmoye}
                  duration={duration}
                  setDuration={setDuration}
                  yearCount={yearCount}
                  monthCount={monthCount}
                  foc={foc}
                  setfoc={setfoc}
                  setLoading={setLoading}
                  setIsPress={setIsPress}
                  loading={loading}
                  isPress={isPress}
                />
              </Tab>
            </Tabs>
          </div>
        </Row>
        <ToastContainer autoClose={1200} />
      </Container>
    </div>
  );
};

export default MainUserSub;
